import React, { useState } from 'react'
import { checkList, fetchBlackList, isIterableArray, useClientInfo } from '../block-slider/utils'
import axios from 'axios'
import { Form, Button, Spinner, Alert } from 'react-bootstrap';


const FormSubscribe = ({ footerText, id }) => {

    const [email, setEmail] = useState('')
    const [subscribeError, setSubscribeError] = useState('')
    const [subscribeStatus, setSubscribeStatus] = useState('')
    const [subscribed, setSubscribed] = useState(localStorage.getItem('galaxy-subsribed'))
    const [checkedAllow, setCheckedAllow] = useState(false)

    const { fetchClientInfo } = useClientInfo()


    const changeForm = (e) => {
        setSubscribeError('')
        setEmail(e.target.value)
    }

    const submitForm = async (e) => {
        e.persist()
        e.preventDefault()

        const result = await fetchBlackList(1);
        const check = checkList(result, email) 
        if (check) {
            setSubscribeError(result.text)
            return
        }
 
        const { ip, browser, app } = await fetchClientInfo()
        const sendBody = {
            'email': email,
            clientInfo: {
                ip, browser, app
            }
        }
        axios.post(`${process.env.REACT_APP_API_BASE}/addsubscriber`, sendBody)
            .then(response => {
                if (response.status === 200) {
                    localStorage.setItem('galaxy-subsribed', true)
                    setSubscribeStatus('Вы успешно подписались!')
                    setSubscribed(true)
                } else {
                    setSubscribeStatus('Ошибка! Попробуйте ещё раз')
                }
            })
            .catch(err => {
                setSubscribeStatus('Ошибка! Попробуйте ещё раз')
            })
    }

    return (
        footerText ?
            <div className='subscribe'>
                <Form.Label>
                    {footerText?.text_under}
                </Form.Label>
                <b>{subscribeStatus}</b>
                {
                    subscribeError &&
                    <Alert variant='danger' onClose={() => setSubscribeError(false)} dismissible>
                        <p style={{ fontSize: 13, margin: 0, fontWeight: 500 }}>{subscribeError}</p>
                    </Alert>
                }
                <Form className="subscribe__form" onSubmit={submitForm}>
                    <Form.Control
                        type="email"
                        className="form__input"
                        required
                        placeholder={footerText?.text_placeholder}
                        onChange={changeForm}
                        value={email}
                    // ref={this.emailField}
                    />
                    <Button variant="primary" type="submit" disabled={subscribed || !checkedAllow} style={{ whiteSpace: 'nowrap' }}>
                        {
                            footerText?.text_button ?
                                !subscribed ? 'Вы подписаны' : footerText?.text_button
                                :
                                <Spinner animation='border' size={'sm'} />
                        }
                    </Button>
                </Form>
                <Form.Check
                    className='pl-0 mt-2 checkbox-footer d-inline-block'
                    type="checkbox"
                    checked={checkedAllow}
                    label={<span dangerouslySetInnerHTML={{ __html: footerText?.textAgree }} />}
                    onChange={(e) => {
                        setCheckedAllow(e.target.checked)
                    }}
                    id={id}
                />
            </div>
            :
            <div />
    )
}

export default FormSubscribe